class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HoverDetails extends HTMLElement {
  constructor() {
    super();
    this.details = this.querySelector('details');
    if (!this.details) return;
    this.hoverTimeout = null;

    this.details.addEventListener('mouseenter', this.onMouseEnter.bind(this));
    this.details.addEventListener('mouseleave', this.onMouseLeave.bind(this));
  }

  onMouseEnter() {
    clearTimeout(this.hoverTimeout);
    this.details.setAttribute('open', '');
    this.details.querySelector('summary').setAttribute('aria-expanded', true);
  }

  onMouseLeave() {
    this.hoverTimeout = setTimeout(() => {
      const submenu = this.details.querySelector('ul');
      if (!this.details.matches(':hover') && (!submenu || !submenu.matches(':hover'))) {
        this.details.removeAttribute('open');
        this.details.querySelector('summary').setAttribute('aria-expanded', false);
      }
    }, 150);
  }
}

customElements.define('hover-details', HoverDetails);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.hoverTimeout = null;

    this.mainDetailsToggle.addEventListener('mouseenter', this.onMouseEnter.bind(this));
    this.mainDetailsToggle.addEventListener('mouseleave', this.onMouseLeave.bind(this));
  }

  onMouseEnter() {
    clearTimeout(this.hoverTimeout);
    this.mainDetailsToggle.setAttribute('open', '');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', true);
  }

  onMouseLeave() {
    this.hoverTimeout = setTimeout(() => {
      const submenu = this.mainDetailsToggle.querySelector('.header__submenu');
      if (!this.mainDetailsToggle.matches(':hover') && (!submenu || !submenu.matches(':hover'))) {
        this.mainDetailsToggle.removeAttribute('open');
        this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
      }
    }, 150);
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.header__inline-menu details').forEach((details) => {
    if (!details.closest('header-menu') && !details.closest('hover-details')) {
      const wrapper = document.createElement('hover-details');
      details.parentNode.insertBefore(wrapper, details);
      wrapper.appendChild(details);
    }
  });
});
